import '../../style/index.less';
import './index.less'; // style dependencies

import '../../affix/style';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/anchor/style/index.js
// module id = 919
// module chunks = 0